const actions = {
  GET_SIM_PIN_INVENTORY_DETAILS: " GET_SIM_PIN_INVENTORY_DETAILS",
  GET_SIM_PIN_INVENTORY_DETAILS_SUCCESS:
    "GET_SIM_PIN_INVENTORY_DETAILS_SUCCESS",
  GET_SIM_PIN_INVENTORY_DETAILS_FAILED: " GET_SIM_PIN_INVENTORY_DETAILS_FAILED",

  ADD_SIM_PIN_INVENTORY: "ADD_SIM_PIN_INVENTORY",
  ADD_SIM_PIN_INVENTORY_SUCCESS: "ADD_SIM_PIN_INVENTORY_SUCCESS",
  ADD_SIM_PIN_INVENTORY_FAILED: "ADD_SIM_PIN_INVENTORY_FAILED",

  GET_SIM_PIN_INVENTORY_LIST: "GET_SIM_PIN_INVENTORY_LIST",
  GET_SIM_PIN_INVENTORY_LIST_SUCCESS: "GET_SIM_PIN_INVENTORY_LIST_SUCCESS",
  GET_SIM_PIN_INVENTORY_LIST_FAILED: "GET_SIM_PIN_INVENTORY_LIST_FAILED",

  GET_SIM_PIN_INVENTORY_VIEW_DETAILS: "GET_SIM_PIN_INVENTORY_VIEW_DETAILS",
  GET_SIM_PIN_INVENTORY_VIEW_DETAILS_SUCCESS:
    "GET_SIM_PIN_INVENTORY_VIEW_DETAILS_SUCCESS",
  GET_SIM_PIN_INVENTORY_VIEW_DETAILS_FAILED:
    "GET_SIM_PIN_INVENTORY_VIEW_DETAILS_FAILED",

  RESET_SIM_PIN_INVENTORY_MESSAGE: "RESET_SIM_PIN_INVENTORY_MESSAGE",

  getSimPinInventory: () => ({
    type: actions.GET_SIM_PIN_INVENTORY_DETAILS,
  }),
  getSimPinInventorySuccess: (result) => ({
    type: actions.GET_SIM_PIN_INVENTORY_DETAILS_SUCCESS,
    result,
  }),
  getSimPinInventoryFailed: (error) => ({
    type: actions.GET_SIM_PIN_INVENTORY_DETAILS_FAILED,
    error,
  }),

  addSimPinInventory: (data, searchData) => ({
    type: actions.ADD_SIM_PIN_INVENTORY,
    payload: { data, searchData },
  }),
  addSimPinInventorySuccess: (message) => ({
    type: actions.ADD_SIM_PIN_INVENTORY_SUCCESS,
    payload: { message },
  }),
  addSimPinInventoryFailed: (error) => ({
    type: actions.ADD_SIM_PIN_INVENTORY_FAILED,
    payload: { error },
  }),

  resetSimPinInventoryMessage: () => ({
    type: actions.RESET_SIM_PIN_INVENTORY_MESSAGE,
  }),

  getSimPinInventoryList: (data) => ({
    type: actions.GET_SIM_PIN_INVENTORY_LIST,
    payload: { data },
  }),
  getSimPinInventoryListSuccess: (result) => ({
    type: actions.GET_SIM_PIN_INVENTORY_LIST_SUCCESS,
    result,
  }),
  getSimPinInventoryListFailed: (error) => ({
    type: actions.GET_SIM_PIN_INVENTORY_LIST_FAILED,
    error,
  }),

  getSimPinInventoryViewDetails: (simPinId) => ({
    type: actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS,
    simPinId,
  }),
  getSimPinInventoryViewDetailsSuccess: (result) => ({
    type: actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS_SUCCESS,
    result,
  }),
  getSimPinInventoryViewDetailsFailed: (error) => ({
    type: actions.GET_SIM_PIN_INVENTORY_VIEW_DETAILS_FAILED,
    error,
  }),
};
export default actions;
